import React, { FC } from 'react'
import { Modal, Form, InputNumber } from 'antd'

export interface Size {
  width: number
  height: number
}

interface SizeModalProps {
  visible: boolean
  onCancel: () => void
  onOk: (size: Size) => void
  initialValues?: Size
}

const SizeModal: FC<SizeModalProps> = ({ visible, onCancel, onOk, initialValues }) => {
  const [form] = Form.useForm<Size>()
  const onOkHandler = () => {
    form.validateFields().then(formData => {
      onOk(formData)
    })
  }
  return (
    <Modal visible={visible} zIndex={10002} title="画布大小" onCancel={onCancel} onOk={onOkHandler}>
      <Form form={form} initialValues={initialValues}>
        <Form.Item
          label="宽度"
          name="width"
          rules={[{ required: true, message: 'width is required' }]}
        >
          <InputNumber min={0} precision={0} style={{ width: '100%' }} placeholder="宽度" />
        </Form.Item>
        <Form.Item
          label="高度"
          name="height"
          rules={[{ required: true, message: 'height is required' }]}
        >
          <InputNumber min={0} precision={0} style={{ width: '100%' }} placeholder="高度" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SizeModal
